import { render, staticRenderFns } from "./Products_4.vue?vue&type=template&id=e78c3bf4&scoped=true&"
import script from "./Products_4.vue?vue&type=script&lang=js&"
export * from "./Products_4.vue?vue&type=script&lang=js&"
import style0 from "./Products_4.vue?vue&type=style&index=0&id=e78c3bf4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78c3bf4",
  null
  
)

export default component.exports